import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, HammerModule, Title } from '@angular/platform-browser';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { NativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconRegistry, MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatLegacyTabsModule } from '@angular/material/legacy-tabs';
import { MatToolbar, MatToolbarModule } from '@angular/material/toolbar';
import { NgModule, ErrorHandler, CSP_NONCE } from '@angular/core';
import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AuthService } from './laas/auth.service';
import { AdminAuthService } from './admin/admin-auth.service';
import { FreshAuthService } from './fresh-app/fresh-auth.services';
import { BaseApi } from './laas/base-api.service';
import { GlobalErrorHandlerService } from './laas/global-error-handler.service';
import { DigireportComponent } from './digireport/digireport.component';
import { DependenciesModule } from './dependencies.module';

// import { FinancialDetailModule } from './laas/financial/financial-detail.module';
// import { IdentityDetailModule } from './laas/identity/identity-detail.module';
import { JwtModule } from '@auth0/angular-jwt';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { AddCoapplicantComponent } from './admin/add-coapplicant/add-coapplicant.component';
import { OpenDialog } from './laas/dialog-for-cbs/dialog.component';
import { OpenDialogYesOrNo } from './laas/dialog-yes-or-no/dialog-yes-or-no.component';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

import { InterceptorService } from './interceptor';
import { TokenServiceService } from './token-service.service';
import { ECDHEncryptionInterceptor } from './interceptors/ecdh-encryption.interceptor';
import { CibilReportService } from './laas/financial/cibil-report/cibil-report.service';
import { AdvancedFilterService } from './core/advanced-filter/advanced-filter.service';
import { InterceptorRespService } from './interceptor-resp';
// import { BnNgIdleService } from 'bn-ng-idle';
// import { TokenInterceptor } from './token-interceptor';
  


export function tokenGetter() {
  return sessionStorage.getItem('HicFCyC7V0mJYg3Yw2BBOQ');
}

/**
 * Reads the CSP nonce from <meta name="ngCspNonce"> in index.html.
 *
 * Angular ships component CSS inside the JS bundle and injects it at runtime as
 * <style> elements. When the CSP carries a nonce, 'unsafe-inline' becomes inert
 * (per spec), so those <style> elements are blocked unless they carry a matching
 * nonce — which is what CSP_NONCE makes Angular stamp on them.
 *
 * The web server substitutes NONCE_PLACEHOLDER with the same per-request nonce it
 * writes into the CSP header. Returning null when it hasn't been substituted lets
 * Angular fall back to un-nonced <style> elements, which still work on any policy
 * that has no nonce (i.e. where 'unsafe-inline' is live) — better than stamping a
 * bogus value that matches nothing.
 */
export function cspNonceFactory(): string | null {
  const meta = document.querySelector('meta[name="ngCspNonce"]');
  const value = meta && meta.getAttribute('content');
  return value && value !== 'NONCE_PLACEHOLDER' ? value : null;
}


@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    PageNotFoundComponent,
    DigireportComponent,
    OpenDialog,
  ],
  imports: [
    BrowserModule,
    HammerModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDialogModule,
    BrowserAnimationsModule,
    CoreModule,
    AppRoutingModule,
    DependenciesModule,
    // FinancialDetailModule,
    NgbDatepickerModule,
    NgbModule,
    MatDatepickerModule,
    NativeDateModule,
    MatLegacyTabsModule,
    MatIconModule,
    MatLegacyCardModule,
    MatToolbarModule,
    MatSnackBarModule,
    MatLegacyInputModule,
    MatSidenavModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: [],
        disallowedRoutes: []
      }
    }),
    ModalModule.forRoot()
  ],
  providers: [
    // Nonce for Angular's runtime-injected component <style> elements, taken from
    // <meta name="ngCspNonce"> in index.html (see cspNonceFactory above).
    { provide: CSP_NONCE, useFactory: cspNonceFactory },
    AuthService,
    AdminAuthService,
    FreshAuthService,
    BaseApi,
    Title,
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: ECDHEncryptionInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorRespService, multi: true },
    BsModalService,
    NgbActiveModal,
    TokenServiceService,
    CibilReportService,
    AdvancedFilterService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(MatIconRegistry: MatIconRegistry) {
    MatIconRegistry.registerFontClassAlias('fontawesome', 'fa');
  }
}

